import { SxProps, Theme } from "@mui/material";

export const daypickerSx: (theme: Theme) => SxProps = (theme) => ({
  width: "100%",
  "& .rdp-month": {
    position: "relative",
    width: "100%",
    margin: 0,
    padding: "0 1em",
  },
  "& .rdp-caption": {
    fontSize: theme.spacing(2.5),
    color: "primary.main",
    textAlign: "left",
  },
  "& .rdp-caption_label": {
    fontSize: theme.spacing(2.5),
  },
  "& .rdp-nav_button": {
    px: 2,
    "& .rdp-nav_icon": {
      width: 12,
      height: 12,
    },
  },
  "& .rdp-nav_button:hover:not([disabled])": {
    backgroundColor: "#fff5f3",
    color: "primary.main",
    borderRadius: "0",
    padding: `0 ${theme.spacing(2)}`,
    px: 2,
  },

  "& .rdp-table": {
    width: "100%",
    maxWidth: "initial",
  },
  "& .rdp-head_cell": {
    color: "#8B9898",
    fontSize: theme.spacing(1.75),
    fontWeight: 400,
  },
  "& .rdp-button": {
    margin: "auto",
    fontSize: theme.spacing(1.875),
    maxWidth: "initial",
    width: "100%",
    fontWeight: 700,
  },
  "& .rdp-button.rdp-day": {
    borderRadius: 0,
    height: theme.spacing(4.5),
    margin: `${theme.spacing(0.5)} 0`,
  },
  "& .rdp-button:hover:not([disabled]):not(.rdp-day_selected)": {
    backgroundColor: "primary.main",
    color: theme.palette.white.main,
  },
  "& .rdp-button.rdp-day_selected": {
    backgroundColor: "primary.main",
  },
  "& .rdp-button.rdp-day_range_middle": {
    backgroundColor: "#fff5f3",
    color: theme.palette.black.main,
  },
});

export const daypickerDesktopSx: (theme: Theme) => SxProps = (theme) => ({
  width: "750px",
  "&.rdp": {
    mt: 0,
  },
  "& .rdp-month.rdp-caption_start": {
    pl: 0,
  },
  "& .rdp-month.rdp-caption_end": {
    pr: 0,
    "&:before": {
      content: "''",
      position: "absolute",
      top: theme.spacing(5),
      left: 0,
      bottom: 0,
      borderLeft: `1px solid ${theme.palette.grey[300]}`,
    },
  },
  "& .rdp-caption_start .rdp-caption": {
    pl: 6,
  },
});

export const daypickerMobileSx: (theme: Theme) => SxProps = (theme) => ({
  width: "100%",
  height: "100%",
  overflow: "auto",
  margin: 0,
  "& .rdp-months": {
    justifyContent: "space-around",
    flexDirection: "column",
    maxWidth: "440px",
    margin: `${theme.spacing(10)} auto`,
    display: "flex",
  },
  "& .rdp-nav": {
    display: "none",
  },
});

export const daypickerSingleSx: SxProps = {
  m: 0,
  pb: 2,
  "& .rdp-caption": {
    transform: `translateX(-4px})`,
  },
};

export const daypickerHideNavSx: SxProps = {
  "& .rdp-nav_button": {
    margin: 0,
    display: "none",
  },
};
